export default {"src":"/_next/static/media/apple-store.3946e3a9.svg","height":58,"width":215,"blurWidth":0,"blurHeight":0};